import React, { forwardRef } from 'react'

const ProvidedService = ({ title, description }) => {
    return (
        <div className="flex flex-col h-full">
            <div className='bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] rounded-t-[15px] rounded-b-[15px] border-r-[2px] border-r-[#A6FFCB] border-l-[2px] border-l-[#1FA2FF] py-[2px] text-center flex flex-col flex-grow'>
                <p className='font-faustina font-semibold 1200:text-[32px] lg:text-[30px] xs:text-[clamp(24px,2.9vw,30px)] text-black pt-[14px] pb-[16px]'>
                    {title}
                </p>
                <div className='bg-black rounded-b-[15px] py-[23px] px-[16px] flex-grow text-justify'>
                    <p className='font-poppins font-regular lg:text-[20px] md:text-[18px] xs:text-[16px] text-white leading-[45px]'>
                        {description}
                    </p>
                </div>
            </div>
        </div>
    );
};
  

export default ProvidedService